import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuyerDetailsRoutingModule } from './buyer-details-routing.module';
import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';

import { BuyerDetailsComponent } from './buyer-details/buyer-details.component';
import { BuyerDetailsNavbarComponent } from './buyer-details-navbar/buyer-details-navbar.component';
import { BuyerDetailsHeaderComponent } from './buyer-details-header/buyer-details-header.component';
import { BuyerDetailsGeneralComponent } from './buyer-details-general/buyer-details-general.component';
import { BuyerDetailsGeneralInfoComponent } from './buyer-details-general-info/buyer-details-general-info.component';
import { BuyerDetailsGeneralCardComponent } from './buyer-details-general-card/buyer-details-general-card.component';
import { BuyerDetailsGeneralDocumentComponent } from './buyer-details-general-document/buyer-details-general-document.component';
import { BuyerDetailsGeneralResidencyComponent } from './buyer-details-general-residency/buyer-details-general-residency.component';
import { BuyerDetailsGeneralAmlComponent } from './buyer-details-general-aml/buyer-details-general-aml.component';
import { BuyerDetailsOrderDataComponent } from './buyer-details-order-data/buyer-details-order-data.component';
import { BuyerDetailsOrderDataTableComponent } from './buyer-details-order-data-table/buyer-details-order-data-table.component';
import { BuyerDetailsEventDataComponent } from './buyer-details-event-data/buyer-details-event-data.component';
import { BuyerDetailsGeneralSddComponent } from './buyer-details-general-sdd/buyer-details-general-sdd.component';

@NgModule({
  declarations: [
    BuyerDetailsComponent,
    BuyerDetailsNavbarComponent,
    BuyerDetailsHeaderComponent,
    BuyerDetailsGeneralComponent,
    BuyerDetailsGeneralInfoComponent,
    BuyerDetailsGeneralCardComponent,
    BuyerDetailsGeneralDocumentComponent,
    BuyerDetailsGeneralResidencyComponent,
    BuyerDetailsGeneralAmlComponent,
    BuyerDetailsOrderDataComponent,
    BuyerDetailsOrderDataTableComponent,
    BuyerDetailsEventDataComponent,
    BuyerDetailsGeneralSddComponent,
  ],
  imports: [
    CommonModule,
    BuyerDetailsRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatRadioModule,
  ],
})
export class BuyerDetailsModule {}
